// Core
export { default as createConnector } from "./core/createConnector.js";
export { instantSearchContext, InstantSearchConsumer, InstantSearchProvider } from "./core/context.js"; // Utils

export { HIGHLIGHT_TAGS } from "./core/highlight.js";
export { default as version } from "./core/version.js";
export { default as translatable } from "./core/translatable.js"; // Widgets

export { default as Configure } from "./widgets/Configure.js";
export { default as ExperimentalConfigureRelatedItems } from "./widgets/ConfigureRelatedItems.js";
import { default as DynamicWidgets } from "./widgets/DynamicWidgets.js";
/** @deprecated use DynamicWidgets */

var ExperimentalDynamicWidgets = DynamicWidgets;
export { ExperimentalDynamicWidgets, DynamicWidgets };
export { default as QueryRuleContext } from "./widgets/QueryRuleContext.js";
export { default as Index } from "./widgets/Index.js";
export { default as InstantSearch } from "./widgets/InstantSearch.js"; // Connectors

export { default as connectAutoComplete } from "./connectors/connectAutoComplete.js";
export { default as connectBreadcrumb } from "./connectors/connectBreadcrumb.js";
export { default as connectConfigure } from "./connectors/connectConfigure.js";
export { default as EXPERIMENTAL_connectConfigureRelatedItems } from "./connectors/connectConfigureRelatedItems.js";
export { default as connectCurrentRefinements } from "./connectors/connectCurrentRefinements.js";
import { default as connectDynamicWidgets } from "./connectors/connectDynamicWidgets.js";
/** @deprecated use connectDynamicWidgets */

var EXPERIMENTAL_connectDynamicWidgets = connectDynamicWidgets;
export { connectDynamicWidgets, EXPERIMENTAL_connectDynamicWidgets };
export { default as connectGeoSearch } from "./connectors/connectGeoSearch.js";
export { default as connectHierarchicalMenu } from "./connectors/connectHierarchicalMenu.js";
export { default as connectHighlight } from "./connectors/connectHighlight.js";
export { default as connectHits } from "./connectors/connectHits.js";
export { default as connectHitsPerPage } from "./connectors/connectHitsPerPage.js";
export { default as connectInfiniteHits } from "./connectors/connectInfiniteHits.js";
export { default as connectMenu } from "./connectors/connectMenu.js";
export { default as connectNumericMenu } from "./connectors/connectNumericMenu.js";
export { default as connectPagination } from "./connectors/connectPagination.js";
export { default as connectPoweredBy } from "./connectors/connectPoweredBy.js";
export { default as connectQueryRules } from "./connectors/connectQueryRules.js";
export { default as connectRange } from "./connectors/connectRange.js";
export { default as connectRefinementList } from "./connectors/connectRefinementList.js";
export { default as connectScrollTo } from "./connectors/connectScrollTo.js";
export { default as connectSearchBox } from "./connectors/connectSearchBox.js";
export { default as connectRelevantSort } from "./connectors/connectRelevantSort.js";
export { default as connectSortBy } from "./connectors/connectSortBy.js";
export { default as connectStateResults } from "./connectors/connectStateResults.js";
export { default as connectStats } from "./connectors/connectStats.js";
export { default as connectToggleRefinement } from "./connectors/connectToggleRefinement.js";
export { default as connectHitInsights } from "./connectors/connectHitInsights.js";
export { default as connectVoiceSearch } from "./connectors/connectVoiceSearch.js"; // Types

export * from "./types/index.js";